'use client'
import { cn, formatTime } from "@/lib/utils"
import { memberButtonVariants } from "../fun-ui/MemberButton"
import { VipLogoLightIcon, XCircleIcon } from "../fun-ui/icons"
import { useUserVip } from "@/stores/appStore";
import { VariantProps } from "class-variance-authority";
import { useUpgradeVip } from "./UpgradeVipButton";
import { Button } from "../fun-ui/Button";
import { useRenewalSonnerOpen } from "@/stores/localStore";
import { MemberPlanText } from "./MemberPlanText";
import type { TouchpointItem } from "@/stores/slices/guideSlice";

export interface RenewalSonnerProps
  extends React.ButtonHTMLAttributes<HTMLDivElement>,
  VariantProps<typeof memberButtonVariants> {
  activedPrice?: number;
  item?: TouchpointItem | null;
  onDismiss?: (item: TouchpointItem) => Promise<void> | void;
}
export const RenewalSonner = ({
  className,
  activedPrice,
  item,
  onDismiss,
  ...props
}: RenewalSonnerProps) => {
  const { upgradeVip } = useUpgradeVip();
  const { vip, vipType, remainingDays, vipExtra } = useUserVip();
  const { open, setOpen } = useRenewalSonnerOpen();
  const touchpointDaysLeft = typeof item?.payload?.daysLeft === 'number'
    ? item.payload.daysLeft
    : undefined;
  const touchpointExpireTime = typeof item?.payload?.expireTime === 'number'
    ? item.payload.expireTime * 1000
    : undefined;
  const displayRemainingDays = touchpointDaysLeft ?? remainingDays;
  const displayExpireTime = touchpointExpireTime ?? vipExtra?.expireTime;
  const handleClose = () => {
    if (item) {
      void onDismiss?.(item);
      return;
    }
    setOpen(false);
  }
  if (!item && !open) {
    return <></>;
  }
  if (!item && vip !== 1) {
    return <></>;
  }
  if (!(typeof displayRemainingDays === 'number' && displayRemainingDays >= 0 && displayRemainingDays <= 15)) {
    return <></>;
  }
  return (
    <div
      className={cn(
        "transition-all text-[#EDDBC0] bg-gradient-to-br from-[#a08669] to-[#553a20] ",
        "flex flex-row items-center h-[72px] rounded-xl px-6 gap-6",
        "absolute bottom-14 left-1/2 -translate-x-1/2 z-[32]",
        className,
      )}
      {
      ...props
      }
    >
      <VipLogoLightIcon size={36} />
      <div className="flex flex-col text-[#F0E1CB]">
        <span className="text-lg font-medium">{
          displayRemainingDays > 0 ? (
            <MemberPlanText vip={vip || 1} vipType={vipType || 'plus'} suffix={`仅剩 ${displayRemainingDays} 天`} />
          ) : (
            <MemberPlanText vip={vip || 1} vipType={vipType || 'plus'} suffix="今日到期" />
          )
        }</span>
        <span className="text-sm">会员有效期至：{formatTime(displayExpireTime!, 'YYYY-MM-DD')}</span>
      </div>
      <Button
        variant="ghost"
        className="bg-[#F0E1CB] text-[#593E23] hover:bg-[#F0E1CB]/90 hover:text-[#593E23]/90 h-[38px] w-[100px] font-medium text-base"
        onClick={() => {
          upgradeVip({
            activedPrice,
          });
          if (item) {
            void onDismiss?.(item);
          }
        }}
      >立即续费</Button>
      <span onClick={handleClose}>
        <XCircleIcon className="cursor-pointer text-[#F0E1CB]/50 hover:text-[#F0E1CB]/70" fill="#593E23" size={20} />
      </span>
    </div>
  )
}